import React, { Component } from 'react'
import { AppBar, Toolbar, withStyles } from '@material-ui/core'

const styles = theme => ({
  appBar: {
    top: 'auto',
    bottom: 0,
    borderTop: `2px solid ${theme.palette.primary.main}`
  },
  toolbar: {
    [theme.breakpoints.up('md')]: {
      width: theme.breakpoints.values.md,
      margin: '0 auto'
    },
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  grow: {
    flexGrow: 1
  }
})

export class BottomBarBase extends Component {
  render() {
    const { classes, children } = this.props

    return (
      <AppBar position="fixed" color="default" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>{children}</Toolbar>
      </AppBar>
    )
  }
}

export const BottomBar = withStyles(styles)(BottomBarBase)
